import {
  BaseManagementJob,
  IManagementJobLog,
  ManagementJobCollection,
  ManagementJobStatus,
  RootCollection,
  type IManagementJob,
} from '@principle-theorem/principle-core/interfaces';
import {
  AddLogRequest,
  CollectionReference,
  Firestore,
  IReffable,
  WithRef,
  all$,
  asColRef,
  subCollection,
  toTimestamp,
  undeletedQuery,
} from '@principle-theorem/shared';
import { type LogSeverity } from 'firebase-functions/lib/logger';
import * as moment from 'moment-timezone';
import { Observable } from 'rxjs';

export class ManagementJob {
  static init<T extends Omit<BaseManagementJob, 'status' | 'deleted'>>(
    data: Omit<T, 'status' | 'deleted'>
  ): BaseManagementJob {
    return {
      ...data,
      status: ManagementJobStatus.Pending,
      deleted: false,
    };
  }

  static col(): CollectionReference<IManagementJob> {
    return asColRef<IManagementJob>(RootCollection.ManagementJobs);
  }

  static all$(): Observable<WithRef<IManagementJob>[]> {
    return all$(undeletedQuery(ManagementJob.col()));
  }

  static logCol<T extends BaseManagementJob>(
    job: IReffable<T>
  ): CollectionReference<IManagementJobLog> {
    return subCollection<IManagementJobLog>(
      job.ref,
      ManagementJobCollection.ManagementJobLogs
    );
  }

  static async addLogMessage<T extends BaseManagementJob>(
    job: IReffable<T>,
    message: string,
    severity: LogSeverity = 'INFO'
  ): Promise<void> {
    await Firestore.addDoc(ManagementJob.logCol(job), {
      ...AddLogRequest.init({
        message,
        severity,
      }),
      deleteAfter: toTimestamp(moment().add(1, 'month')),
    });
  }
}
